export default class Reevoo {
    constructor(parent){
        this.parent = parent;
        this.bind();
    }

    bind(){
        if(document.querySelector('.reevooAnalyticsEvent')){
            document.addEventListener('mousedown', (e) => this.target(e)?.matches('.analyticsEvent.reevooBadgeHolder') ? this.parent.trackCustom(e) : null);
            document.addEventListener('keydown', (e) => this.target(e)?.matches('.analyticsEvent.reevooBadgeHolder') ? this.parent.trackCustom(e) : null);
            document.addEventListener('touchend', (e) => this.target(e)?.matches('.analyticsEvent.reevooBadgeHolder') ? this.parent.trackCustom(e) : null);
            document.addEventListener('click', (e) => this.target(e)?.matches('.reevooAnalyticsEvent') ? this.send(e) : null);
        }
    }

    send(e){
        const el = this.target(e);
        const a = el.dataset.analytics;
        if(a){
            const data = JSON.parse(a);
            reevooMark(data.type, data.trkref, { reviewableContext: { sku: data.sku, cta: data.cta } });
        }
    }

    target(e){
        return e.target?.closest('a');
    }
}